// concentric rings from the site's closing section
export const Rings = ({ className = 'rings' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 1600 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
    {[250, 375, 500, 625, 750, 875, 1000, 1125].map((r) => (
      <circle key={r} cx="800" cy="450" r={r} />
    ))}
  </svg>
);
